import React from 'react';
import { Translate } from 'react-jhipster';
import { Button, Modal, ModalBody, Row, ModalHeader, Col } from 'reactstrap';
import { Link } from 'react-router-dom';
import { Home_Network } from 'app/config/constants';

export interface IHomeNetworkModalProps {
  showModal: boolean;
  handleClose: Function;
  handleOnclick: Function;
}

class HomeNetworkModal extends React.Component<IHomeNetworkModalProps> {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <div>
        <Modal className="hide-border-bottom-modal" id="modalUserExists" isOpen={this.props.showModal} backdrop="static">
          <ModalHeader toggle={this.props.handleClose}>
            <label style={{fontSize: '20px'}} className="font-weight-bold">Chọn nhà mạng</label>
          </ModalHeader>
          <ModalBody className="padding-modal-body">
            <Row className="justify-content-center" style={{ flex: 1, padding: '0 20px', paddingBottom: '20px' }}>
              <Col className="borderImg" style={{ flex: 1 }} onClick={() => this.props.handleOnclick(Home_Network.VINA)}>
                <img
                  className="center-block"
                  style={{ marginBottom: '25px', marginTop: '27px' }}
                  src={require('app/images/Vinaphone_Logo.png')}
                  alt=""
                />
              </Col>
              <Col className="borderImg" style={{ flex: 1 }} onClick={() => this.props.handleOnclick(Home_Network.MOBI)}>
                <img
                  className="center-block"
                  style={{ marginBottom: '25px', marginTop: '32px' }}
                  src={require('app/images/logo-mobifone.png')}
                  alt=""
                />
              </Col>
              <Col className="borderImg" style={{ flex: 1 }} onClick={() => this.props.handleOnclick(Home_Network.VIETTEL)}>
                <img className="center-block" style={{ marginBottom: '25px' }} src={require('app/images/Logo_Viettel.png')} alt="" />
              </Col>
            </Row>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}

export default HomeNetworkModal;
